<!--
Displays navbar for each screen.
Usage: <Nav name="text" :home="boolean" />
@author ab557z, crm4f
-->
<template>
  <header>
    <nav class="navbar navbar-dark" :style="{ 'background-color': bannerColour }">
      <div class="backAndHeader">
        <span id="backSpan" v-if="props.back" v-on:click="goBack" @keyup.enter="goBack" tabindex="0">
          <font-awesome-icon id="arrow" style="color:white;" icon="arrow-left" size="lg"/>
        </span>
        <span id="backSpan" v-if="!props.back"></span>
        <div style="min-width: 0;">
          <span class="navbarTitle">{{ props.name }}</span>
        </div>
      </div>
      <div>
        <span v-if="showNotif" v-on:click="go('/notifications')" class="notifIcon"><img v-if="unreadNum>0" id="bellNotiImg" src="@/assets/noti-bell.svg" alt="Unread notifications"/><img v-else id="bellImg" src="@/assets/bell.svg" alt="Notifications - no unread notifications"/></span>
      </div>
    </nav>
    <div v-if="bannerImage != null" class="bannerImage" :style="`background-image:url('${bannerImage}')`"></div>
  </header>
</template>

<script setup>
import * as lst from '@/components/localStorage.js'
import axios from 'axios'
import { onMounted, defineProps, ref } from 'vue'
import { useRouter } from 'vue-router'
import {useRouteHistory} from '@/composables/History.js'

const props = defineProps({
  name: {
    type: String
  },
  home: {
    type: Boolean,
    default: false
  },
  back: {
    type: Boolean,
    default: true
  },
  step: {
    type: Boolean,
    default: false
  },
  showNotif: {
    type: Boolean,
    default: true
  }
})

const router = useRouter()
// eslint-disable-next-line no-unused-vars
const homeBtn = ref(props.home)
const authenticated = ref(lst.getValue('authenticated'))
const unreadNum = ref(lst.getValue('unreadNotifications'))
const bannerImage = ref(null)
const bannerColour = ref('#011451')
const currentAppTheme = ref(1)

onMounted(() => {
  // console.log('authenticated = ' + authenticated.value)
  if (isTrue(authenticated.value)) {
    getCurrentAppTheme()
  }
})

function isTrue(val) {
  let ret = false
  if (val == true || val == 'true') {
    ret = true
  }
  return ret
}

function getCurrentAppTheme() {
  axios.get('/timetable/banners/category/42', {})
    .then(response => {
      // get the app-wide theme id
      let banners = response.data.banners
      if (typeof banners !== 'undefined' && banners.length > 0) {
        currentAppTheme.value = banners[0].content
        getBannerColour()
        getBannerImage()
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

function getBannerColour () {
  axios.get('/timetable/theme/element/' + currentAppTheme.value + '/colour', {})
    .then(response => {
      let colour = response.data
      // if this theme has no colour, default to uofg blue
      if (colour == "") {
        bannerColour.value = "#011451"
      } else {
        bannerColour.value = colour.elementValue
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

function getBannerImage () {
  axios.get('/timetable/theme/element/' + currentAppTheme.value + '/banner', {})
    .then(response => {
      // take one banner and display it
      let image = response.data
      if (image != "" && isValidUrl(image.elementValue)) {
        bannerImage.value = image.elementValue
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

function isValidUrl(urlString) {
  let url
  
  try {
    url = new URL(urlString)
  } catch (_) {
    return false; 
  }

  return url.protocol === "http:" || url.protocol === "https:"
}

function goBack () {
  if (props.home == true || props.step == true || authenticated.value == null) {

    const {previousRoute, historyStack} = useRouteHistory()
    
    const isPreviousRouteMenu = previousRoute.value?.path === "/menu"
    const historyHas2Entries = historyStack.value.length > 2
    
    //Want to avoid going back to the menu if possible
    //If previous page is menu page and history has has an entry before that, go back 2
    if (isPreviousRouteMenu && historyHas2Entries) {
      router.go(-2)
    } else {
      router.go(-1)
    }
  } else {
    router.push('/')
  }
}

// eslint-disable-next-line no-unused-vars
function goHome () {
  router.push('/')
}

</script>

<style scoped lang="scss">
.bannerImage {
  width: 100%;
  background-size: contain;
  height: 30px;
}

.notifIcon {
  float: right;
  margin-bottom: 20px;
  margin-left: 5px;
  margin-right: 20px;
  margin-top: 20px;
}

.backAndHeader {
  display: flex;
  align-items: center;
  max-width: 75%;
}

.navbarTitle {
  color:white;
  text-align:center;
  font-weight:bold;
  font-size:25px;
  word-wrap: break-word;
  white-space: normal;
}

.navbar {
  padding-left:0px;
  padding-right:0px;
  /* Status bar height on iOS 10 */
  padding-top: 20px;
  /* Status bar height on iOS 11.0 */
  padding-top: constant(safe-area-inset-top);
  /* Status bar height on iOS 11+ */
  padding-top: env(safe-area-inset-top);
  box-shadow: 0px 5px 6px rgba(205, 200, 200, 0.25);
}

#arrow {
  color: var(--uog-dark-blue);
  margin-bottom:1px;
}

#backSpan {
  padding-left:10px;
  padding-right:10px;
  padding-top: 3px;
}

#homeSpan {
  padding-left:16px;
  padding-top:80px;
  padding-bottom:16px;
  padding-right:18px;
}

#info {
  margin-bottom:1px;
}

#bellImg {
  width: 20px;
  height: 23px;
  cursor: pointer;
}

#bellNotiImg {
  width: 23px;
  height: 28px;
  cursor: pointer;
}

</style>
